var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.25H4C3.80109 6.25 3.61032 6.32902 3.46967 6.46967C3.32902 6.61032 3.25 6.80109 3.25 7V25C3.25 25.1989 3.32902 25.3897 3.46967 25.5303C3.61032 25.671 3.80109 25.75 4 25.75H28C28.1989 25.75 28.3897 25.671 28.5303 25.5303C28.671 25.3897 28.75 25.1989 28.75 25V7C28.75 6.80109 28.671 6.61032 28.5303 6.46967C28.3897 6.32902 28.1989 6.25 28 6.25ZM10.75 18.25V13.75H21.25V18.25H10.75ZM4.75 18.25V13.75H9.25V18.25H4.75ZM22.75 13.75H27.25V18.25H22.75V13.75ZM27.25 12.25H16.75V7.75H27.25V12.25ZM15.25 7.75V12.25H4.75V7.75H15.25ZM4.75 19.75H15.25V24.25H4.75V19.75ZM16.75 24.25V19.75H27.25V24.25H16.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall);
export default __webpack_public_path__ + "static/media/wall.714638537f98877114483d6c9ac7f7e6.svg";
export { ForwardRef as ReactComponent };